const COOKIE_NAME = 'cuc-session';
const COOKIE_DOMAIN = '.cucollaborate.com';
export const SESSION_POLL_INTERVAL_MS = 2000;

export function setSessionCookie(value: string): void {
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(
    value
  )}; Domain=${COOKIE_DOMAIN}; Path=/; Secure; SameSite=Lax`;
}

export function clearSessionCookie(): void {
  document.cookie = `${COOKIE_NAME}=; Domain=${COOKIE_DOMAIN}; Path=/; Secure; SameSite=Lax; Expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}

export function readSessionCookie(): string | null {
  const match = new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]*)`).exec(
    document.cookie
  );
  return match ? decodeURIComponent(match[1]) : null;
}
